import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import PiWriterTable from './table/PiWriterTable';
import PiWriterEditForm from './editform/PiWriterEditForm';

i18next.addResourceBundle('en', 'piWriter', en);
i18next.addResourceBundle('hu', 'piWriter', hu);

export default [
	{
		path: '/pi-writer/edit/:id/:tabKey?',
		component: PiWriterEditForm,
		auth: authRoles.piWriter
	},
	{
		path: '/pi-writer/:sessionNameParam?',
		component: PiWriterTable,
		auth: authRoles.piWriter
	}
];
